import {
  UseCreateValidationsListProps,
  UseCreateValidationsListReturn,
} from './types'
import { VALIDATION_CONFIGS } from '../../constants/validationConfigs'

import {
  FeatureActionType,
  FeatureType,
  useGetFeaturesSettings,
} from '@/domain/settings'
import { useUserStore } from '@/store'
import { generateRandomId } from '@/utils'

export const useCreateValidationsList = ({
  feature,
}: UseCreateValidationsListProps): UseCreateValidationsListReturn => {
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)

  const { data: remoteSettings, isLoading: isLoadingRemoteSettings } =
    useGetFeaturesSettings(
      {
        feature,
      },
      {
        enabled: !!feature,
      },
    )

  const filteredFeature = remoteSettings?.features[feature as FeatureType]
  const actions = filteredFeature?.actions ?? []

  const hasRequiredAction = (type: FeatureActionType) =>
    actions.some((a) => a.data_type === type && a.required)

  const validations = VALIDATION_CONFIGS.map((config) => ({
    id: generateRandomId(),
    title: config.title,
    iconName: config.iconName,
    iconBgColor: config.iconBgColor,
    isPending: config.isPending(userAuthenticated),
    isDisabled: config.isDisabled(userAuthenticated, actions),
    disabledMessage: config.disabledMessage?.(userAuthenticated, actions),
    isVisible: hasRequiredAction(config.type),
    onPress: config.onPress,
  }))

  // Sort validations: pending items first, non-pending items at the end
  const sortedValidations = validations.sort((a, b) => {
    if (a.isPending && !b.isPending) return -1 // a goes first
    if (!a.isPending && b.isPending) return 1 // b goes first
    return 0 // keep original order for items with same pending status
  })

  return {
    validations: sortedValidations,
    isLoading: isLoadingRemoteSettings,
  }
}
